module.exports = __webpack_public_path__ + "img/home-service-zhuhai.4c1c04df.png";